module.exports = __webpack_public_path__ + "public/images/curated-what-is-outschool-frame.049f5e0bb67153a8e8c5603344616253.svg";